import { render, staticRenderFns } from "./NewAllowance.vue?vue&type=template&id=03fd3e95"
import script from "./NewAllowance.vue?vue&type=script&lang=js"
export * from "./NewAllowance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports